<template>
    <div>

        <!-- /////////////////////////////////////////////////////
            //             PANTALLA PRINCIPAL     //
            /////////////////////////////////////////////////////    -->

        <v-col cols="12" sm="12" md="12" class="pb-0 px-0">
            <v-alert dense border="left"  class="text-center" color="#0277bd" dark>
                <h5>LISTADO DE DOCENTES</h5>
                <h5>Estudiante: {{alumno[0].apellido_nombre}}</h5>
            </v-alert>
        </v-col>

         <!--  ruta_avatar_persona  avatar_persona  -->
         <v-row>
            <v-col cols="4" v-for="item in datos" :key="item.id" class="mb-4">
                <v-card class="" max-width="400">
                    <v-row class="pl-1">
                        <v-col cols="4">
                            <v-avatar v-if="configColegio.rest_estudiante_docente_avatar" color="grey" size="65" class="ml-3">
                                <v-icon v-if="!item.avatar_persona" color="grey-darken-3">fa-solid fa-user</v-icon>
                                <img v-else 
                                     :src="`${rutaServer+item.ruta_avatar_persona+item.avatar_persona}`"
                                     class="fondo_add_img"
                                     dark
                                     size="100" />
                            </v-avatar>

                            <v-avatar color="grey" size="65" v-if="configColegio.rest_estudiante_docente_avatar==false" class="ml-3">
                                <v-icon color="grey-darken-3">fa-solid fa-user</v-icon>
                            </v-avatar>
                        </v-col>

                        <v-col cols="8">
                            <h5 class="font-weight-regular text-grey">Apellidos y nombres:</h5>
                            <h4 class="font-weight-bold">{{item.nombre_pers}}</h4>

                            <h5 class="font-weight-regular text-grey">Curso:</h5>
                            <h4 class="font-weight-bold">{{item.desc_curso}}</h4>

                            <h5 class="font-weight-regular text-grey" v-if="configColegio.rest_estudiante_docente_correo">Correo electrónico:</h5>
                            <h4 class="font-weight-bold" v-if="configColegio.rest_estudiante_docente_correo">{{item.correo_persona}}</h4>

                            <h5 class="font-weight-regular text-grey" v-if="configColegio.rest_estudiante_docente_curso">Teléfono:</h5>
                            <h4 class="font-weight-bold" v-if="configColegio.rest_estudiante_docente_curso">{{item.telf_persona}}</h4>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <!-- fin de pantalla principal -->

         <br>
        
        
        <span v-if="test">
            <!--
            <code>Alumno: {{JSON.stringify(alumno)}}</code> <br>
            <code>Datos: {{JSON.stringify(datos)}}</code>
            <code>ConfigColegio: {{JSON.stringify(configColegio)}}</code>
            -->
            <code>Datos: {{JSON.stringify(datos)}}</code>

        </span> 

    </div>
</template>

<script>
    import axios, {API_URL} from "@/helpers/axios";
    import { mapMutations, mapGetters, mapActions } from "vuex";

    export default {
        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente: { id_submodulo: 146, id_modulo: 7 }, //sud_modulo y modulo

            datoLogin: sessionStorage, // variables de sesion del usuario
            rutaServer: API_URL,
            test:false,
            ////////////////////////////////////////////////////////

            datos: [],
            alumno: [],
            configColegio:{}
        }),



        computed: {
            ...mapGetters("login", ["componenteEvento"]),
        },

        mounted() {
            this.loadMain();
        },


        created() {
            this.actualizarParamentro();
        },


        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //----- Validar accesos por perfil ------------
            ...mapActions("login", ["parametroComponente"]),

            actualizarParamentro() {
            this.parametroComponente(this.paramComponente);
            },

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations("mensajeSis", ["setEnviarMens"]),
            ////////////////////////////////////////////////////////


            //  ------- MOSTRAR TODOS LOS REGISTROS    --------
            async loadMain() {
                //this.defaultSeccion.id_grado = item.id
                let id_colegio = sessionStorage.id_colegio
                let id_periodo = sessionStorage.id_ano_lectivo
                let id_persona = sessionStorage.id_persona

                try {
                    let response = await axios.get(`/academico/docente/listDocente/colegio/${id_colegio}/ano_lectivo/${id_periodo}/persona/${id_persona}`);
                    let datos = response.data

                    this.alumno = datos.alumno
                    this.datos = datos.docentesSeccion
                    this.configColegio = datos.configColegio

                }
                catch (error) {
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }
            },



        },
    };
</script>

<style scoped>
    .fondo_add_img {
        padding-left: 0;
        padding-right: 0;
        margin-left: 0;
        margin-right: 0;
        cursor: pointer;
        cursor: hand;
        border: 4px solid #fff;
        border-color: #474545;
        color: #524f4f;
    }

    .fondo_add_img:hover {
        border-color: #b3b3b3;
        color: #b3b3b3;
    }
</style>